import React from 'react';
import './BouncingDots.sass';

interface BouncingDotsProps {
  className?: string;
}

function BouncingDots({ className }: BouncingDotsProps): React.JSX.Element {
  return (
    <div className={`bouncing-dots-loader ${className ?? ''}`}>
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
}

export default BouncingDots;
